import { ButtonBase, Stack, Typography } from '@mui/material'
import { FC, MouseEvent } from 'react'
import { IconButton, Icons } from 'utoniq-ui'

export enum FileType {
  Audio = 'audio',
  Magazine = 'magazine',
  Video = 'video',
  Image = 'image',
}

export type UploadBoxProps = {
  type: `${FileType}`
  filename?: string
  applied?: boolean
  variant?: 'rectangle' | 'square'
  onClick: (event: MouseEvent<HTMLButtonElement>) => void
  onRemove?: (event: MouseEvent<HTMLButtonElement>) => void
}

export const UploadBox: FC<UploadBoxProps> = ({
  type,
  filename,
  applied,
  onRemove,
  onClick,
}) => {
  if (!applied) {
    return null
  }

  if (type === FileType.Image) {
    return null
  }
  const Icon = icons[type]

  return (
    <ButtonBase
      sx={{
        bgcolor: 'grey.100',
        justifyContent: 'space-between',
        height: 50,
        borderRadius: 1,
        px: 5,
      }}
      onClick={onClick}
    >
      <Stack direction="row" alignItems="center" spacing={2} flex={1}>
        <Icon fontSize="small" />
        <Typography variant="body2">{filename}</Typography>
      </Stack>
      {onRemove && (
        <IconButton.Close
          size="small"
          edge="end"
          onClick={event => {
            event.stopPropagation()
            event.preventDefault()
            onRemove(event)
          }}
        />
      )}
    </ButtonBase>
  )
}

const icons = {
  video: Icons.Video,
  audio: Icons.Audio,
  magazine: Icons.Magazine,
}
